// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__10YN0","name":"Header_name__1T8-2","birthday":"Header_birthday__2jdje","skeleton":"Header_skeleton__2ashL"};